import styled from 'styled-components';

export const VerticalFormWrapper = styled.form`
  .ant-form-item {
    flex-direction: column;
  }
  .ant-form-item-label > label {
    height: auto;
  }
  .ant-form-item-label,
  .ant-col-24.ant-form-item-label,
  .ant-col-xl-24.ant-form-item-label {
    padding: 0 0 8px;
    line-height: 1.5715;
    white-space: initial;
    text-align: left;
  }
  .ant-form-item-label > label,
  .ant-col-24.ant-form-item-label > label,
  .ant-col-xl-24.ant-form-item-label > label {
    margin: 0;
  }
  .ant-form-item-label > label::after,
  .ant-col-24.ant-form-item-label > label::after,
  .ant-col-xl-24.ant-form-item-label > label::after {
    display: none;
  }
  .ant-form-rtl.ant-form-vertical .ant-form-item-label,
  .ant-form-rtl.ant-col-24.ant-form-item-label,
  .ant-form-rtl.ant-col-xl-24.ant-form-item-label {
    text-align: right;
  }
`;
